export default {
    data() {
        return {
            dates: {
                start_date: null,
                end_date: null,
                balance_sheet_date: '31.12.',
                start_on_entry: true,
                end_indefinite: true,
                convocation_days: 14,
                agenda_supplement_days: 11,
                consultation_days: 7,
            },
        };
    },
    watch: {
        'dates.start_on_entry': function (selected) {
            if (selected) {
                this.dates.start_date = null;
            }
        },
        'dates.end_indefinite': function (selected) {
            if (selected) {
                this.dates.end_date = null;
            }
        },
        'dates.convocation_days': function (days) {
            this.dates.agenda_supplement_days = days - 3;
        },
    },
    methods: {
        setNoticeWaiver() {
            this.termDetails.waiver_of_notice = this.dates.balance_sheet_date + ((new Date).getFullYear() + 3);

            _.forEach(this.obligations.loss_coverage, (lossCoverage, id) => {
                lossCoverage.date = this.dates.balance_sheet_date + ((new Date).getFullYear() + 3);
                console.log(lossCoverage.date)
            });

            _.forEach(this.obligations.management_duty, (managementDuty, id) => {
                managementDuty.date = this.dates.balance_sheet_date + ((new Date).getFullYear() + 3);
            });

            _.forEach(this.obligations.obligation_cooperate, (obligationCooperate, id) => {
                obligationCooperate.date = this.dates.balance_sheet_date + ((new Date).getFullYear() + 3);
            });
        }
    }
};
